<template>
  <el-dialog :visible.sync="visible" width="1100px" height="700px" @close="handleCancel" title="巡检任务详情" :is-footer="false">
    <div class="history-info" style="height: 500px">
      <div class="history-info__basic">
        <h3 class="info-title">基本信息</h3>
        <div class="basic-info">
          <div class="basic-info__item">
            <div class="item-label">任务名称</div>
            <div class="item-value">{{ taskInfo.taskName }}</div>
          </div>
          <!-- <div class='basic-info__item'>
            <div class='item-label'>巡检日期</div>
            <div class='item-value'>{{taskInfo.planTime}}</div>
          </div> -->
          <div class="basic-info__item">
            <div class="item-label">计划巡检时间</div>
            <div class="item-value">
              {{ formatDateTime(taskInfo.startDate) }}~{{ formatDateTime(taskInfo.endDate) }}
            </div>
          </div>
          <div class="basic-info__item">
            <div class="item-label">实际巡检时间</div>
            <div class="item-value">
              {{ formatDateTime(taskInfo.actualStartDate) }}~{{ formatDateTime(taskInfo.actualEndDate) }}
            </div>
          </div>
          <div class="basic-info__item">
            <div class="item-label">巡检人员</div>
            <div class="item-value">
              {{ dealArrayToString(taskInfo.users, "username") }}
            </div>
          </div>
          <div class="basic-info__item">
            <div class="item-label">是否逾期</div>
            <div class="item-value">
              {{ taskInfo.isTimeout == "1" ? "是" : "否" }}
            </div>
          </div>
        </div>
        <div class="basic-status">
          {{ dealValueToLabel(taskInfo.taskStatus, statusData) }}
        </div>
      </div>
      <div class="history-info__abnormal">
        <h3 class="info-title">巡检设备</h3>
        <el-table :is-pagination="false" :columns="tableColumns" :data="tableData" style="max-height: 280px;overflow-y: auto;">
          <el-table-column type="index" label="序号" align="cneter"></el-table-column>
          <el-table-column prop="resName" label="巡检设备" align="cneter"></el-table-column>
          <el-table-column prop="standardName" label="巡检标准" align="cneter"></el-table-column>
          <el-table-column prop="clockUser" label="巡检人" align="cneter"></el-table-column>
          <el-table-column prop="taskDetailRemarks" label="巡检项(漏检数/异常数/总数)" align="cneter" width="200"></el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="scope">
              <!-- <el-image v-if="scope.row.picture" style="width: 60px; height: 60px" :src="getImgPath(scope.row.picture)"
                fit="cover" :preview-src-list="[getImgPath(scope.row.pictureArr)]" /> -->
              <div style="cursor: pointer;" v-if="scope.row.pictureArr.length > 0">
                <img width="60" height="60" :src="getImgPath(scope.row.pictureArr[0])" @click="showViewer(scope.row.pictureArr, $event)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="详情" align="cneter">
            <template slot-scope="scope">
              <i class="soc iconView" @click="handleView(scope.row)" style="cursor: pointer;" />
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="el-table__empty-block">
              <span class="el-table__empty-text">
                <div class="ioc-crud__empty">
                  <div class="ioc-empty">
                    <div class="ioc-empty__image" style="height: 50px">
                      <img src="../img/empty.svg" alt="" />
                    </div>
                    <p class="ioc-empty__desc">暂无数据</p>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="viewVisible" append-to-body width="600px" height="400px" title="巡检详情" :is-footer="false">
      <div style="height: 500px; overflow-y: auto; overflow-x: hidden;">
        <div class="device-patrol-details">
          <div class="details-item" v-for="(item, index) in details" :key="index">
            <div class="details-item__info">
              <div class="entryName">{{ index + 1 }}.{{ item.itemName }}</div>
              <div class="unit">单位：{{ item.itemUnit }}</div>
              <div class="recordMethod">
                类型：{{ dealType(item.showType) }}
              </div>
            </div>
            <div class="candidates">候选项：{{ item.options }}</div>
            <div class="reply">答复：{{ item.itemValue }}</div>
            <!-- <div class="remark">异常描述：{{ item.remark }}</div> -->
            <div class="remark">异常描述：{{ item.taskItemRemarks }}</div>
          </div>
        </div>
        <div v-if="details.pictureArr && details.pictureArr.length > 0">图片：</div>
        <div style="cursor: pointer; display: inline-block; margin: 10px 10px 10px 0" v-for="(imgItem, imgIndex) in details.pictureArr" :key="imgIndex">
          <img width="100" height="100" :src="getImgPath(imgItem)" @click="showViewer([imgItem], $event)" />
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import api from "../api/index";
import utils from "@src/common/utils";
export default {
  name: "historyInfoComponent",
  props: {
    id: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      viewVisible: false,
      taskInfo: {},
      details: [],
      tableColumns: [
        {
          label: "序号",
          prop: "index",
          width: 80,
        },
        {
          label: "巡检设备",
          prop: "resName",
        },
        {
          label: "巡检标准",
          prop: "standardName",
        },
        {
          label: "巡检人",
          prop: "clockUser",
        },
        {
          label: "巡检项(漏检数/异常数/总数)",
          prop: "taskDetailRemarks",
        },
        {
          label: "图片",
          prop: "picture",
        },
        {
          label: "详情",
          prop: "details",
        },
      ],
      tableData: [],
      statusData: [
        { label: "全部任务", value: "" },
        { label: "未开始", value: "0" },
        { label: "执行中", value: "1" },
        { label: "已完成", value: "2" },
      ],
      typeArr: [
        { label: "单选", value: "0" },
        { label: "多选", value: "1" },
        { label: "数字", value: "2" },
        { label: "文本", value: "3" },
      ],
    };
  },
  mounted() {
    this.visible = true;
    this.queryTakDetail(this.id);
  },
  methods: {
    showViewer(url, e) {
      let imgArr = url.map((item) => {
        return this.getImgPath(item);
      });
      this.$app.AppInstance.handleShowViewer(imgArr);
    },
    formatDateTime(value) {
      if (value) {
        const date = new Date(value);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        var second = date.getSeconds();
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      } else {
        return "";
      }
    },
    getImgPath(item) {
      return item ? utils.Bus.imgPath(item) : "";
    },
    // 把设备类型转换成设备类型名字
    dealType(value) {
      let result = "";
      this.typeArr.forEach((item) => {
        if (item.value == value) {
          result = item.label;
        }
      });
      return result;
    },
    dealArrayToString(arr, label) {
      let result = "";
      if (arr && arr.length) {
        let arrlist = arr.map((item) => {
          return item[label];
        });
        result = arrlist.join(",");
      }
      return result;
    },
    // 获取任务详情
    queryTakDetail(id) {
      let url = api.task.getTaskDetail + `${id}` + "/detail";
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          res.data.devices.forEach((item) => {
            if (item.submitImage) {
              // let submitImage = JSON.parse(item.submitImage).picture;
              let submitImage = item.submitImage;
              let submitImageArr = submitImage.split(",");
              item.picture = submitImageArr[0];
              item.pictureArr = submitImageArr;
            } else {
              item.picture = "";
              item.pictureArr = [];
            }
          });
          this.taskInfo = res.data;
          this.tableData = res.data.devices;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleView(row) {
      this.details.pictureArr = []
      this.viewVisible = true;
      let url =
        api.task.queryDeviceItemList + `?taskDetailId=${row.taskDetailId}`;
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          let list = res.data;
          let question = [];
          list.forEach((item) => {
            if (item.showType == "0") {
              //单选
              let obj = {
                itemName: item.itemName,
                itemId: item.itemId,
                itemValue: item.itemValue ? item.itemValue : item.defaultValue,
                showType: item.showType,
                itemUnit: item.itemUnit,
                taskItemRemarks: item.taskItemRemarks,
              };
              let option = [item.upValue, item.downValue];

              obj.options = option.join(",");
              question.push(obj);
            } else if (item.showType == "1") {
              //多选
              let obj = {
                itemName: item.itemName,
                itemId: item.itemId,
                itemValue: item.itemValue ? item.itemValue : item.defaultValue,
                showType: item.showType,
                itemUnit: item.itemUnit,
                taskItemRemarks: item.taskItemRemarks,
              };
              let optionstr1 = item.upValue ? item.upValue.split(",") : [];
              let optionstr2 = item.downValue ? item.downValue.split(",") : [];
              let optionsArr = optionstr1.concat(optionstr2);
              let option = optionsArr.map((i) => {
                return i;
              });
              obj.options = option.join(",");
              question.push(obj);
            } else if (item.showType == "2") {
              //  数字
              let obj = {
                itemName: item.itemName,
                itemId: item.itemId,
                itemValue: item.itemValue
                  ? String(item.itemValue)
                  : String(item.defaultValue),
                showType: item.showType,
                itemUnit: item.itemUnit,
                taskItemRemarks: item.taskItemRemarks,
              };
              question.push(obj);
            } else if (item.showType == "3") {
              //文本
              let obj = {
                itemName: item.itemName,
                itemId: item.itemId,
                itemValue: item.itemValue ? item.itemValue : item.defaultValue,
                showType: item.showType,
                itemUnit: item.itemUnit,
                taskItemRemarks: item.taskItemRemarks,
              };
              question.push(obj);
            }
          });
          this.details = question;
          this.details.pictureArr = row.pictureArr;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    imgPath(url) {
      return url;
    },
    // 选项value和label之前的转换
    dealValueToLabel(value, arr) {
      let result = "";
      if (!value || !arr) {
        return result;
      } else {
        arr.forEach((item) => {
          if (item.value == value) {
            result = item.label;
          }
        });
        return result;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.history-info {
  display: flex;
  flex-direction: column;
  height: 100%;

  .info-title {
    // color: #fff;
    border-left-width: 3px;
    border-left-style: solid;
    padding-left: 10px;
    border-left-color: #407aee;
  }

  &__basic {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 20px;

    .basic-info {
      display: flex;
      flex-wrap: wrap;

      &__item {
        // background-color: #2b3452;
        padding: 6px 10px;
        line-height: 20px;
        width: 426px;
        margin-right: 20px;
        margin-top: 16px;
        display: flex;
        align-items: center;

        .item-label {
          margin-right: 10px;
        }

        .item-value {
          flex: 1;
          width: 0;
          word-break: break-all;
          // color: white;
        }
      }
    }

    .basic-status {
      position: absolute;
      width: 100px;
      height: 100px;
      border: 1px solid #a4a7b1;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      // color: #ffff00;
      color: rgb(64, 122, 238);
      right: 15px;
      top: 75px;
      font-size: 20px;
      font-weight: bold;
    }
  }

  &__abnormal {
    // display: flex;
    // flex-direction: column;
    // flex: 1;
    // height: 0;
    // max-height: 300px;
    // overflow-y: auto;

    .info-title {
      margin-bottom: 16px;
    }
  }
}

.device-patrol-details {
  display: flex;
  flex-direction: column;

  .details-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    &__info {
      display: flex;
      margin-bottom: 10px;
    }

    .entryName {
      width: 200px;
    }

    .unit {
      width: 150px;
    }

    .candidates,
    .reply,
    .remark {
      margin-left: 12px;
      margin-bottom: 10px;
    }
  }
}
</style>
